import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { HiOutlineChatBubbleLeftRight } from "react-icons/hi2";
import { HiTrash } from "react-icons/hi";
import ProjectInfoEditBanner from "./components/ProjectEditBanner/ProjectEditBanner";
import ProjectInfoEditModal from "./components/ProjectInfoEditModal/ProjectInfoEditModal";
import MainImageCard from "./components/MainImageCard/MainImageCard";
import EditInfoForm from "./components/EditInfoForm/EditInfoForm";
import OpenApplicationsCard from "./components/OpenApplicationCard/OpenApplicationCard";
import ApplicantsCard from "./components/ApplicantsCard/ApplicantsCard";
import MembersCard from "./components/MembersCard/MembersCard";
import ActiveNotificationBanner from "../../notifications/components/activeNotificationBanner/activeNotificationBanner";

import validateOneLiner from "../../../components/codiOS/utils/validateOneLiner";
import validateProjectDescription from "../../../components/codiOS/utils/validateProjectDescription";
// import validateRoleDescription from "../../../components/codiOs/utils/validateRoleDescription";
import { validateWithCodi } from "../../../components/codiOS/utils/validateWithCodi";
import Roadmap from "./components/Roadmap/Roadmap";
import ProjectPointsCard from "./components/ProjectPointsCard/ProjectPointsCard";
import TeamMembersCard from "./components/TeamMembersCard/TeamMembersCard";
import ProjectCalendar from "./components/ProjectCalendar/ProjectCalendar";
import CodiOS from "../../../components/codiOS/codiOS";
import { computePhaseProgress } from "../adminView/utils/computePhaseProgress";

import "./adminView.css";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AdminView = ({ collapsed, setCollapsed }) => {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const storedUsername = localStorage.getItem("username");

  // Declare user BEFORE using it
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem("user");
    return savedUser ? JSON.parse(savedUser) : null;
  });
  const [roadmaps, setRoadmaps] = useState([]);
  const [submissions, setSubmissions] = useState([]);

  const [teamMembers, setTeamMembers] = useState([]);
  const [fieldErrors, setFieldErrors] = useState({});

  const [showEditModal, setShowEditModal] = useState(false);

  const [showImageModal, setShowImageModal] = useState(false);
  const [newImageFile, setNewImageFile] = useState(null);

  useEffect(() => {
    if (user && user.email && !storedUsername) {
      const derivedUsername = user.email.split("@")[0];
      localStorage.setItem("username", derivedUsername);
    }
  }, [user, storedUsername]);

  const [projectData, setProjectData] = useState(null);
  const [project, setProject] = useState(null);
  const [email, setEmail] = useState("");
  const [capital, setCapital] = useState(null);
  
  const [openRoles, setOpenRoles] = useState([]);
  const [isHovered, setIsHovered] = useState(false);
  const [activeNoti, setActiveNoti] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [updatedProject, setUpdatedProject] = useState({});
  const [triggerRoleRefresh, setTriggerRoleRefresh] = useState(0);
  const [toastAlerts, setToastAlerts] = useState(true);

  const [showCodiOS, setShowCodiOS] = useState(false);
  const [codiLaunchMode, setCodiLaunchMode] = useState(null);

  const token = localStorage.getItem("token");

  // Fetch Project
  useEffect(() => {
    let isMounted = true;

    const fetchProject = async () => {
      setLoading(true);
      const token = localStorage.getItem("token");

      if (!token) {
        setError("Unauthorized: No token.");
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${BACKEND_URL}/projects/${projectId}/admin-view`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) throw new Error("Failed to load project.");

        const data = await response.json();
        console.log("✅ Admin View Data:", data);

        if (isMounted) {
          if (!data.project) {
            setError("Project data not found.");
            return;
          }

          // Always include a valid ID
          const projectInfo = {
            ...data.project,
            id: data.id || data.project.id || projectId,
          };

          // Convert Firestore Timestamp to JS Date object
          if (projectInfo.updatedAt?._seconds) {
            projectInfo.updatedAt = new Date(projectInfo.updatedAt._seconds * 1000);
          } else {
            projectInfo.updatedAt = null;
          }

          // Ensure image URL is valid
          const imageUrl =
            projectInfo.image?.trim() || "https://via.placeholder.com/300";
          projectInfo.image = imageUrl;

          // Sync all project states cleanly
          setProject(projectInfo);
          setProjectData(projectInfo);
          // setUpdatedProject(projectInfo);
          setUpdatedProject({
            title: projectInfo.title || "",
            oneLiner: projectInfo.oneLiner || "",
            description: projectInfo.description || "",
            image: imageUrl,
          });

          console.log("🎯 Project Data Set:", projectInfo);
        }
      } catch (error) {
        if (isMounted) {
          setError(error.message);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchProject();

    return () => {
      isMounted = false;
    };
  }, [projectId]);


  // useEffect(() => {
  //   const fetchCapital = async () => {
  //     try {
  //       const token = localStorage.getItem("token");
  //       if (!token || !projectId) return;

  //       const res = await fetch(`${BACKEND_URL}/projects/${projectId}/capital`, {
  //         method: "GET",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       });

  //       if (!res.ok) throw new Error("Failed to fetch capital");
  //       const data = await res.json();

  //       console.log("💰 Capital Data:", data);
  //       setCapital(data.capital || null);
  //     } catch (err) {
  //       console.error("❌ Error fetching capital:", err);
  //     }
  //   };

  //   fetchCapital();
  // }, [projectId]);
  
  // Fetch User Preferences ( settings )
  useEffect(() => {
    const fetchUserPreferences = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;
  
        const res = await fetch(`${BACKEND_URL}/user/preferences`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
  
        const data = await res.json();
        if (res.ok && data.preferences) {
          console.log("🧠 Loaded toastAlerts setting:", data.preferences.toastAlerts);
          setToastAlerts(data.preferences.toastAlerts);
        } else {
          console.warn("⚠️ Couldn't load toastAlerts preference.");
        }
      } catch (err) {
        console.error("❌ Error loading toastAlerts:", err);
      }
    };
  
    fetchUserPreferences();
  }, []);
  
  // Noti for a new role
  useEffect(() => {
    const openedRoleNoti = localStorage.getItem("justOpenedRoleNoti");
    if (openedRoleNoti) {
      const parsed = JSON.parse(openedRoleNoti);
      setActiveNoti({
        type: "role_opened",
        message: `🆕 A new role "${parsed.roleTitle}" has been opened for your project "${parsed.projectTitle}".`,
      });
      localStorage.removeItem("justOpenedRoleNoti");
    }
  }, []);

  // Noti for role status
  useEffect(() => {
    const statusToggleNoti = localStorage.getItem("justToggledRoleStatus");
    if (statusToggleNoti) {
      const { roleTitle, status } = JSON.parse(statusToggleNoti);
      const capitalizedStatus = status.charAt(0).toUpperCase() + status.slice(1);
  
      setActiveNoti({
        type: "role_status_toggled",
        message: `✅ "${roleTitle}" role is ${capitalizedStatus} successfully.`,
      });
  
      localStorage.removeItem("justToggledRoleStatus");
    }
  }, []);
  
  // Noti for role delete
  useEffect(() => {
    const deletedRoleNoti = localStorage.getItem("justDeletedRoleNoti");
    if (deletedRoleNoti) {
      const { roleTitle } = JSON.parse(deletedRoleNoti);
  
      setActiveNoti({
        type: "role_deleted",
        message: `🗑️ The role "${roleTitle}" was deleted successfully.`,
      });
  
      localStorage.removeItem("justDeletedRoleNoti");
    }
  }, []);
  
  // Noti for saving Project Changes
  useEffect(() => {
    const updatedProjectNoti = localStorage.getItem("justUpdatedProjectNoti");
    if (updatedProjectNoti) {
      const { projectTitle } = JSON.parse(updatedProjectNoti);
  
      setActiveNoti({
        type: "project_updated",
        message: `📁 Your project "${projectTitle}" was updated successfully.`,
      });
  
      localStorage.removeItem("justUpdatedProjectNoti");
    }
  }, []);

  // Sync updatedProject with project data after fetching
  useEffect(() => {
    if (project) {
      setUpdatedProject({
        title: project.title || "",
        oneLiner: project.oneLiner || "",
        description: project.description || "",
      });
    }
  }, [project]);

  // Fetch User Profile
  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;

        const response = await fetch(`${BACKEND_URL}/auth/profile`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const userData = await response.json();
          setUser(userData);
        } else {
          console.error("Error fetching profile:", response.status);
        }
      } catch (error) {
        console.error("Profile Fetch Error:", error);
      }
    };

    fetchUserProfile();
  }, []);

  // Fetch Open Roles
  useEffect(() => {
    const fetchOpenRoles = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;

        const response = await fetch(`${BACKEND_URL}/applications/${projectId}/open-roles-admin`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await response.json();
        if (response.ok) {
          setOpenRoles(data.openRoles || []);
          console.log("✅ Open Roles Fetched:", data.openRoles);
        } else {
          console.error("Error fetching open roles:", data.message);
        }
      } catch (error) {
        console.error("Error fetching open roles:", error);
      }
    };

    fetchOpenRoles();
  }, [projectId, triggerRoleRefresh]);

  // Fetch Roadmaps, Assignments, Pickups, and Submissions
  useEffect(() => {
    const fetchRoadmapsAndAssignmentsAndPickups = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.warn("⚠️ No token found.");
          return;
        }

        console.log("🚀 Fetching Roadmaps + Assignments + Pickups + Submissions for:", projectId);

        // --- Step 1: Fetch Roadmaps, Assigned Members, and Pickups in parallel ---
        const [roadmapRes, assignedRes, pickupsRes] = await Promise.all([
          fetch(`${BACKEND_URL}/roadmaps/${projectId}`, {
            method: "GET",
            headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
          }),
          fetch(`${BACKEND_URL}/roadmaps/${projectId}/assigned-members`, {
            method: "GET",
            headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
          }),
          fetch(`${BACKEND_URL}/roadmaps/${projectId}/pickups`, {
            method: "GET",
            headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
          }),
        ]);

        const roadmapData = await roadmapRes.json();
        const assignedData = await assignedRes.json();
        const pickupsData = await pickupsRes.json();

        console.log("📦 Raw Roadmap API Data:", roadmapData);
        console.log("👥 Assigned Data:", assignedData);
        console.log("👐 Pickups Data:", pickupsData);

        if (!roadmapData || !Array.isArray(roadmapData.roadmaps) || roadmapData.roadmaps.length === 0) {
          console.error("❌ No roadmaps found in API response!");
          setRoadmaps([]);
          setSubmissions([]);
          return;
        }

        // --- Step 2: Extract roadmapId for submissions ---
        const roadmapId = roadmapData.roadmaps[0].id;
        console.log("🧭 Using Roadmap ID for submissions fetch:", roadmapId);

        // --- Step 3: Fetch submissions ---
        const submissionsRes = await fetch(`${BACKEND_URL}/submissions/${roadmapId}`, {
          method: "GET",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        });
        const submissionsData = await submissionsRes.json();

        console.log("📬 Submissions Data:", submissionsData);

        // --- Step 4: Build assignment/pickup maps ---
        const assignedMap = {};
        (assignedData.assignedCheckpoints || []).forEach((a) => {
          assignedMap[`${a.phase}-${a.index}`] = a.assignedTo;
        });

        const pickupMap = {};
        (pickupsData.pickedUpCheckpoints || []).forEach((p) => {
          pickupMap[`${p.phase}-${p.index}`] = p.pickedUpBy;
        });

        // --- Step 5: Format roadmap phases ---
        let formatted = roadmapData.roadmaps.flatMap((rm) =>
          (rm.phases || []).map((phase) => ({
            ...phase,
            roadmapId: rm.id,
            checkpoints: (phase.checkpoints || []).map((cp, i) => ({
              ...cp,
              index: i,
              assignedTo: assignedMap[`${phase.title}-${i}`] || null,
              pickedUpBy: pickupMap[`${phase.title}-${i}`] || null,
              progress: cp.progress || { percent: 0, lastUpdated: null },
            })),
          }))
        );

        // --- Step 6: Merge submission data into checkpoints ---
        if (submissionsData?.submissions?.length) {
          formatted = formatted.map((phase) => {
            const updatedCheckpoints = (phase.checkpoints || []).map((cp) => {
              const relatedSubs = submissionsData.submissions.filter(
                (s) => s.phase === phase.title && s.checkpointIndex === cp.index
              );

              if (!relatedSubs.length) return cp;

              const avgProgress =
                relatedSubs.reduce((sum, s) => sum + (s.progressDelta || 0), 0) /
                relatedSubs.length;

              const updatedPercent = Math.min(100, (avgProgress * 100).toFixed(0));
              const lastSub = relatedSubs[relatedSubs.length - 1];

              return {
                ...cp,
                progress: {
                  percent: updatedPercent,
                  lastUpdated: lastSub?.createdAt || cp.progress?.lastUpdated,
                },
              };
            });

            // compute phase-wide average progress
            const avgPhaseProgress =
              updatedCheckpoints.length > 0
                ? Math.round(
                    updatedCheckpoints.reduce((sum, c) => sum + (c.progress?.percent || 0), 0) /
                      updatedCheckpoints.length
                  )
                : 0;

            return { ...phase, checkpoints: updatedCheckpoints, progress: avgPhaseProgress };
          });
        }

        console.log("🎯 Formatted + Merged Roadmaps:", formatted);
        console.log("🧩 Submissions Count:", submissionsData.submissions?.length || 0);

        // --- Step 7: Compute accurate phase progress before saving ---
        const computed = computePhaseProgress(formatted, submissionsData.submissions || []);
        setRoadmaps(computed);
        setSubmissions(submissionsData.submissions || []);

      } catch (err) {
        console.error("🔥 Fetch Error:", err);
      }
    };

    fetchRoadmapsAndAssignmentsAndPickups();
  }, [projectId]);
  
  useEffect(() => {
    const fetchTeamMembersAdmin = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;

        const res = await fetch(
          `${BACKEND_URL}/projects/${projectId}/team-members-admin`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!res.ok) throw new Error("Failed to fetch team members (admin)");
        const data = await res.json();

        console.log("Admin Team Members:", data.members);

        // Normalize structure if backend returns { members: [...] }
        setTeamMembers(data.members || []);
      } catch (err) {
        console.error("❌ Error fetching team members (admin):", err);
      }
    };

    fetchTeamMembersAdmin();
  }, [projectId]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  const validateAdminFields = async () => {
  const newErrors = {};

  if (!updatedProject.title.trim()) {
    newErrors.title = "Project title is required.";
  }

  const oneLinerCheck = validateOneLiner(updatedProject.oneLiner || "");
  if (!oneLinerCheck.valid) {
    newErrors.oneLiner =
      oneLinerCheck.reason === "too short"
        ? "One-liner is too short."
        : "One-liner is too long.";
  } else {
    const oneLinerMeaning = await validateWithCodi(updatedProject.oneLiner);
    if (!oneLinerMeaning.valid)
      newErrors.oneLiner = oneLinerMeaning.reason || "One-liner lacks clarity.";
  }

  const descCheck = validateProjectDescription(updatedProject.description || "");
  if (!descCheck.valid) {
    newErrors.description =
      descCheck.reason === "too short"
        ? "Description is too short."
        : "Description is too long.";
  } else {
    const descMeaning = await validateWithCodi(updatedProject.description);
    if (!descMeaning.valid)
      newErrors.description = descMeaning.reason || "Description lacks clarity.";
  }

  return newErrors;
};

  const handleSaveChanges = async () => {
    try {
        const validationErrors = await validateAdminFields();
          if (Object.keys(validationErrors).length > 0) {
            console.warn("🛑 Validation failed:", validationErrors);
            alert("Please fix the highlighted errors before saving.");
            setFieldErrors(validationErrors); // Set errors
            return;
          }
          setFieldErrors({}); // Clear errors if valid
          const token = localStorage.getItem("token");
          if (!token) {
              alert("User not authenticated");
              return;
          }

        let imageBase64 = null;

        // ✅ Convert Image File to Base64 if Updated
        if (updatedProject.image instanceof File) {
            const reader = new FileReader();
            reader.readAsDataURL(updatedProject.image);
            reader.onload = () => {
                imageBase64 = reader.result.split(",")[1]; // Remove "data:image/jpeg;base64," prefix
            };
            await new Promise((resolve) => (reader.onloadend = resolve));
        }

        // ✅ Prepare Request Body
        const requestBody = {
            title: updatedProject.title || "",
            oneLiner: updatedProject.oneLiner || "",
            description: updatedProject.description || "",
            image: imageBase64, // Base64 Image
        };

        console.log("📡 Sending project update with:", requestBody);

        const response = await fetch(`${BACKEND_URL}/projects/${projectId}/update`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(requestBody),
        });

        if (!response.ok) throw new Error(`Failed to update project: ${response.statusText}`);

        const data = await response.json();
        console.log("✅ Project updated successfully:", data.updatedProject);
        alert("✅ Project updated successfully!");
        setProject(data.updatedProject);

        localStorage.setItem("justUpdatedProjectNoti", JSON.stringify({
          projectTitle: data.updatedProject?.title || "Untitled Project",
        }));
        window.location.reload();

    } catch (error) {
        console.error("❌ Error updating project:", error);
        alert("Failed to update project.");
    }
};

const handleDeleteProject = async () => {
  const confirmDelete = window.confirm("Are you sure you want to delete this entire project?");
  if (!confirmDelete) return;

  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${BACKEND_URL}/projects/${projectId}/delete`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) throw new Error("Failed to delete project");

    alert("Project deleted successfully");
    localStorage.setItem("justDeletedNoti", project?.title || "Untitled Project");

    const derivedUsername = user?.username || user?.email?.split("@")[0] || localStorage.getItem("username");
    navigate(`/${derivedUsername}/explore`); 
  } catch (error) {
    console.error("❌ Error deleting project:", error);
    alert("Error deleting project");
  }
};

const handleDeleteRole = async (roleId) => {
  const confirmDelete = window.confirm("Are you sure you want to delete this role?");
  if (!confirmDelete) return;

  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${BACKEND_URL}/applications/roles/${roleId}/delete`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) throw new Error("Failed to delete role");

    // Update local state
    setOpenRoles((prev) => prev.filter((r) => r.id !== roleId));
    alert("Role deleted successfully");

    localStorage.setItem("justDeletedRoleNoti", JSON.stringify({ roleTitle: openRoles.find(r => r.id === roleId)?.roleTitle || "Untitled Role" }));
    window.location.reload();

  } catch (error) {
    console.error("Error deleting role:", error);
    alert("Failed to delete role.");
  }
};

  return (
    <div className="flex flex-col gap-6 max-w-7xl mx-auto mt-4 w-full px-2 sm:px-4 lg:px-6">
      {toastAlerts && activeNoti && (
        <ActiveNotificationBanner
          notification={activeNoti}
          onClose={() => setActiveNoti(null)}
        />
      )}

      <div className="flex flex-col gap-6 mx-auto mt-4 w-full max-w-[calc(100%-80px)]">
        <ProjectInfoEditBanner
          project={project}
          onEdit={() => setShowEditModal(true)}
          onDelete={handleDeleteProject}
          // navigateToHub={() => {
          //   const projectIdToUse = project?.id || projectData?.id || projectId;
          //   if (!projectIdToUse) return;
          //   navigate(`/projects/${projectIdToUse}/collaborate`);
          // }}
          // onImageClick={() => setShowImageModal(true)}
          isAdmin={true}
        />

        {/* Project Points, Applicants, Team Members Cards */}
        <div className="flex flex-wrap justify-between gap-4 pb-2 px-2">
          {/* First points card */}
          {/* <ProjectPointsCard
            base={capital?.base || 0}
            earned={capital?.earned || 0}
            goal={1000}
            className="flex-1 min-w-[280px] max-w-[320px] transition-transform duration-300 hover:-translate-y-2 hover:shadow-xl hover:shadow-indigo-200"
          /> */}

          {/* Applicants Section */}
          <div
            className="flex-1 min-w-[280px] max-w-[320px] h-52 bg-white rounded-[20px] p-4 shadow-sm flex flex-col 
                      transition-transform duration-300 hover:-translate-y-2 hover:shadow-xl hover:shadow-blue-200 animate-fadeIn"
          >
            <h3 className="text-sm font-semibold text-gray-800 mb-2">Applicants</h3>
            <div className="flex-1 overflow-y-auto space-y-2 pr-1">
              {openRoles.length > 0 ? (
                openRoles.map((role) => (
                  <ApplicantsCard
                    key={role.id}
                    roleId={role.id}
                    projectId={projectId}
                    roleTitle={role.roleTitle}
                    compact={true}
                  />
                ))
              ) : (
                <p className="text-xs text-gray-500 italic animate-pulse">
                  No applicants yet.
                </p>
              )}
            </div>
          </div>

          {/* Third Team Members card */}
          <TeamMembersCard
            projectId={projectId}
            teamMembers={teamMembers}
            projectOwner={project?.owner}
            className="flex-1 min-w-[280px] max-w-[320px] transition-transform duration-300 hover:-translate-y-2 hover:shadow-xl hover:shadow-green-200 animate-fadeIn"
          />
        </div>

        <ProjectCalendar
          projectId={projectId} 
          roadmaps={roadmaps}
          teamMembers={teamMembers}
          submissions={submissions}
          isAdmin={true}
        />

        <OpenApplicationsCard
          onRoleAdded={() => setTriggerRoleRefresh((prev) => prev + 1)}
          projectTitle={project?.title}
        />

        {openRoles.length > 0 && (
          <div className="bg-white rounded-xl p-4 shadow-sm w-full">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">Current Open Roles</h3>
            <div className="space-y-4">
              {openRoles.map((role) => (
                <div
                  key={role.id}
                  className="p-4 bg-gray-50 rounded-lg shadow-sm border flex flex-col gap-2 w-full"
                >
                  <div className="flex justify-between items-start w-full">
                    <div className="min-w-0">
                      <p className="font-bold text-gray-800 break-words">{role.roleTitle}</p>
                      <p className="text-sm text-gray-600 break-words">{role.description}</p>
                      <p className="text-xs text-gray-500 mt-1">
                        Created on:{" "}
                        {new Date(role.createdAt).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })}
                      </p>
                    </div>
                    <div className="flex gap-2 items-center flex-shrink-0">
                      <label className="relative inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          className="sr-only peer"
                          checked={role.status !== "closed"}
                          onChange={async (e) => {
                            const newStatus = e.target.checked ? "open" : "closed";
                            const token = localStorage.getItem("token");
                            try {
                              const res = await fetch(
                                `${BACKEND_URL}/applications/roles/${role.id}/status`,
                                {
                                  method: "PATCH",
                                  headers: {
                                    "Content-Type": "application/json",
                                    Authorization: `Bearer ${token}`,
                                  },
                                  body: JSON.stringify({ newStatus }),
                                }
                              );
                              if (!res.ok) throw new Error("Failed to update role status");
                              localStorage.setItem(
                                "justToggledRoleStatus",
                                JSON.stringify({ roleTitle: role.roleTitle, status: newStatus })
                              );
                              window.location.reload();
                            } catch (err) {
                              console.error("Error toggling role status:", err);
                              alert("Failed to update role status.");
                            }
                          }}
                        />
                        <div className="w-11 h-6 bg-gray-300 rounded-full peer-checked:bg-blue-600 transition-colors duration-300"></div>
                        <div className="absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full transition-transform duration-300 peer-checked:translate-x-5"></div>
                      </label>
                      <button
                        onClick={() => handleDeleteRole(role.id)}
                        className="text-red-500 hover:text-red-700"
                      >
                        <HiTrash className="w-5 h-5" />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="bg-white rounded-xl p-4 shadow-sm w-full">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">Roadmap View</h3>
          <Roadmap
            roadmaps={roadmaps}
            submissions={submissions}
            isAdmin={true}
            onCreateRoadmap={() => {
              const currentProject = project || projectData;
              console.log("currentProject:", currentProject);

              if (!currentProject?.id) {
                console.warn("⚠️ Project data not ready — cannot open CodiOS yet");
                return;
              }

              console.log("🚀 Launching CodiOS with:", currentProject);
              setCodiLaunchMode("roadmap");
              setShowCodiOS(true);
            }}
          />

        </div>
      </div>

      {/* Popup with Project Info + Image */}
      {showEditModal && (
        <div className="fixed inset-0 bg-black/50 z-[9999] flex justify-center items-center">
          <div
            className="bg-white rounded-xl shadow-lg w-full max-w-lg relative flex flex-col"
            style={{ maxHeight: "90vh" }} // lock modal height relative to viewport
          >
            {/* Close Button */}
            <button
              onClick={() => setShowEditModal(false)}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
            >
              ✕
            </button>

            {/* Scrollable Content */}
            <div className="overflow-y-auto p-6 space-y-6">
              {/* Project Image Upload */}
              <MainImageCard
                project={project}
                onImageUpdate={(file) => {
                  setUpdatedProject((prev) => ({ ...prev, image: file }));
                }}
              />

              {/* Header */}
              <div className="flex justify-between items-start">
                <div>
                  <h2 className="text-xl font-bold text-gray-900">Your Project Info</h2>
                  <span className="mt-1 inline-block text-xs px-3 py-1 bg-blue-100 text-blue-700 rounded-full">
                    {project?.category || "No Category"}
                  </span>
                </div>
                {/* <div className="flex gap-2 items-center">
                  <button
                    onClick={() => {
                      const projectIdToUse = project?.id || projectData?.id || projectId;
                      if (!projectIdToUse) return;
                      navigate(`/projects/${projectIdToUse}/collaborate`);
                    }}
                    className="flex items-center text-sm text-gray-700 hover:text-black font-medium"
                  >
                    <HiOutlineChatBubbleLeftRight className="mr-1 w-4 h-4" />
                    Hub
                  </button>
                  <button
                    onClick={handleDeleteProject}
                    className="text-red-500 hover:text-red-700"
                    title="Delete Project"
                  >
                    <HiTrash className="w-5 h-5" />
                  </button>
                </div> */}
              </div>

              {/* Project Info Form */}
              <EditInfoForm
                updatedProject={updatedProject}
                setUpdatedProject={setUpdatedProject}
                fieldErrors={fieldErrors}
                setFieldErrors={setFieldErrors}
                isAdmin={true}
                readOnly={false}
              />

              {/* Tags */}
              <div>
                {project?.tags?.length > 0 ? (
                  <div className="flex flex-wrap gap-2">
                    {project.tags.map((tag, index) => (
                      <span
                        key={index}
                        className="bg-gray-200 text-gray-800 px-3 py-1 text-xs rounded-full"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                ) : (
                  <p className="text-sm text-gray-400">No Tags Available</p>
                )}
              </div>

              {/* Save Button */}
              <div>
                <button
                  onClick={handleSaveChanges}
                  className="w-full bg-black text-white py-2.5 rounded-lg text-sm font-semibold hover:bg-gray-900 transition"
                >
                  Save Changes
                </button>
              </div>

              {/* Last Updated */}
              {project?.updatedAt && (
                <p className="text-xs text-gray-400 text-right">
                  Last updated:{" "}
                  {new Date(project.updatedAt).toLocaleString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </p>
              )}
            </div>
          </div>
        </div>
      )}

      {showCodiOS && (
        <CodiOS
          onClose={() => setShowCodiOS(false)}
          initialMode={codiLaunchMode}
          project={{
            id: project.id, 
            title: project.title,
            oneLiner: project.oneLiner,
            description: project.description,
            category: project.category,
            tags: project.tags,
          }}
        />
      )}

    </div>

  
  );

};


export default AdminView;
